var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: ["button-group", { active: _vm.isActive }] }, [
    _c(
      "button",
      {
        class: ["button", "rewind", { disabled: _vm.isRewindDisabled }],
        attrs: { tabindex: _vm.isRewindDisabled ? -1 : 0 },
        on: { click: _vm.rewindClicked },
      },
      [_c("i", { staticClass: "fa fa-backward" })]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        class: ["button", "play-pause", "play", { hide: !_vm.isPaused }],
        attrs: { tabindex: "0" },
        on: { click: _vm.playClicked },
      },
      [_c("i", { staticClass: "fa fa-play" })]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        class: ["button", "play-pause", "pause", { hide: _vm.isPaused }],
        attrs: { tabindex: "0" },
        on: { click: _vm.pauseClicked },
      },
      [_c("i", { staticClass: "fa fa-pause" })]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        class: [
          "button",
          "fast-forward",
          { disabled: _vm.isFastForwardDisabled },
        ],
        attrs: { tabindex: _vm.isFastForwardDisabled ? -1 : 0 },
        on: { click: _vm.fastForwardClicked },
      },
      [_c("i", { staticClass: "fa fa-forward" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }